import type { IMessageBase } from './base';

export const MESSAGE_TYPE = 'LOG_DIAGNOSTICS';

export interface IMessageLogDiagnostics extends IMessageBase {
    type: 'LOG_DIAGNOSTICS';
    payload: Record<string, never>;
}
